import { useState } from "react";
import EmptyDataOverlay from "../../../components/empty-data-overlay";
import TaskGroupReportsTable from "./task-group-reports-table";
import {
  ReportProgress,
  UserWeeklyReportsResponse,
} from "../../../redux/features/report-slice";
import { ArrowDownOutlined } from "../../../components/icons/arrow-down-outlined";

interface Props {
  reports: UserWeeklyReportsResponse[];
  onRefresh: () => void;
}

export default function ReportsTab(props: Props) {
  const { reports, onRefresh } = props;

  const [toggleTaskGroup, setToggleTaskGroup] = useState<{
    [id: string]: boolean;
  }>({});

  return (
    <div className="overflow-y-scroll space-y-4">
      {reports.length > 0 ? (
        reports.map((report: UserWeeklyReportsResponse, index: number) => {
          const orgName = report.taskGroup.taskFunction.organization.name;
          const orgColor =
            orgName === "Head Office"
              ? "#7d003c"
              : orgName === "HCM Office"
              ? "#0e7ab0"
              : "#a37402";
          {
            return Object.keys(report.progress).map((progress: string) => (
              <div
                key={index}
                className={`border border-divider rounded-lg cursor-pointer hover:bg-action-hover ${
                  toggleTaskGroup[`${report.taskGroup.id}-${progress}`]
                    ? "bg-action-hover"
                    : "bg-background-paper"
                }`}
              >
                <div
                  className="flex items-center justify-between p-4"
                  onClick={() => {
                    setToggleTaskGroup((prevState) => ({
                      ...prevState,
                      [`${report.taskGroup.id}-${progress}`]:
                        !prevState[`${report.taskGroup.id}-${progress}`],
                    }));
                  }}
                >
                  <div className="w-8/12 flex items-center">
                    <ArrowDownOutlined
                      className={`h-4 mr-4 transition-transform duration-300 ${
                        toggleTaskGroup[`${report.taskGroup.id}-${progress}`]
                          ? "transform rotate-180"
                          : ""
                      }`}
                    />
                    <div className="w-11/12 font-medium">
                      <label>{report.taskGroup.title}</label>
                      <div className="flex items-center space-x-1">
                        <label
                          className="text-xs whitespace-nowrap font-medium"
                          style={{ color: orgColor }}
                        >
                          {report.taskGroup.taskFunction.organization.name}
                        </label>
                        <label>•</label>
                        <label className="text-xs line-clamp-1 text-text-title">
                          {report.taskGroup.taskFunction.title}
                        </label>
                        {report.taskGroup.branch !== null && (
                          <label className="text-xs whitespace-nowrap text-text-title">
                            {`/ ${report.taskGroup.branch.name}`}
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="w-2/12 flex flex-col">
                    <label className="text-sm text-text-title">Progress</label>
                    <label
                      className={`font-semibold text-sm capitalize ${
                        progress === ReportProgress.None
                          ? "text-gray-500"
                          : progress === ReportProgress.Pending
                          ? "text-error-main"
                          : progress === ReportProgress.Inprogress
                          ? "text-warning-main"
                          : "text-success-main"
                      }`}
                    >
                      {progress}
                    </label>
                  </div>
                  <div className="w-2/12 flex flex-col">
                    <label className="text-sm text-text-title">
                      Total Duration
                    </label>
                    <label className="text-text-primary font-medium">
                      {report.progress[progress].totalDuration}
                    </label>
                  </div>
                  <div className="w-2/12 flex flex-col">
                    <label className="text-sm text-text-title">
                      Total Quantity
                    </label>
                    <label className="text-text-primary font-medium">
                      {report.progress[progress].totalQuantity}
                    </label>
                  </div>
                  {/* <div className="w-2/12 flex flex-col">
                  <label className="text-sm text-text-title">
                    Avg. Time
                  </label>
                  <label className="text-text-primary font-medium">
                    {fractionOfDayToTimeString(
                      report.progress[progress].totalDuration /
                        (report.progress[progress].totalQuantity !== 0
                          ? report.progress[progress].totalQuantity
                          : 1)
                    )}
                  </label>
                </div> */}
                </div>
                <div
                  className={`${
                    toggleTaskGroup[`${report.taskGroup.id}-${progress}`]
                      ? "slide-down"
                      : "slide-up overflow-hidden"
                  }`}
                >
                  <TaskGroupReportsTable
                    reports={report.progress[progress].reports}
                    onRefresh={onRefresh}
                  />
                </div>
              </div>
            ));
          }
        })
      ) : (
        <EmptyDataOverlay label="No Reports found" exClassName="h-96" />
      )}
    </div>
  );
}
